/*******************************************************************************
 * Copyright (c) 2025 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import { createTheme } from '@mui/material/styles';

// assets
import navySttr from './scss/navy-sttr.module.scss';
import colorsDefault from './scss/commercial.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';
import customShadows from './shadows';

/**
 * All available SCSS themes
 */
const themeMap = {
    'Navy STTR1': navySttr,
    'Commercial': colorsDefault,
    DEFAULT: colorsDefault,
};

/**
 * Get current theme colors based on env variable
 */
const getThemeColors = () => {
    const themeName = process.env.REACT_APP_THEME_MODE || 'DEFAULT';
    return themeMap[themeName] || themeMap.DEFAULT;
};

export const theme = (settings) => {
    const colors = getThemeColors();

    const themeOption = {
        colors,
        mode: settings.mode || 'light',
        heading: '',
        paper: '',
        backgroundDefault: '',
        background: '',
        darkTextPrimary: '',
        darkTextSecondary: '',
        textDark: '',
        menuSelected: '',
        menuSelectedBack: '',
        divider: '',
        settings,
    };

    if (settings.mode === 'dark') {
        themeOption.paper = colors.darkLevel2;
        themeOption.backgroundDefault = colors.darkLevel2;
        themeOption.background = colors.darkBackground;
        themeOption.darkTextPrimary = colors.darkTextPrimary;
        themeOption.darkTextSecondary = colors.darkTextSecondary;
        themeOption.textDark = colors.darkTextPrimary;
        themeOption.menuSelected = colors.darkSecondaryMain;
        themeOption.menuSelectedBack = colors.darkSecondaryMain;
        themeOption.divider = colors.darkTextPrimary;
        themeOption.heading = colors.darkTextTitle;
    } else {
        themeOption.paper = colors.paper;
        themeOption.backgroundDefault = colors.paper;
        themeOption.background = colors.primaryLight;
        themeOption.darkTextPrimary = colors.grey700;
        themeOption.darkTextSecondary = colors.grey500;
        themeOption.textDark = colors.grey900;
        themeOption.menuSelected = colors.secondaryDark;
        themeOption.menuSelectedBack = colors.secondaryLight;
        themeOption.divider = colors.grey200;
        themeOption.heading = colors.grey900;
    }

    return createTheme({
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': { minHeight: '48px' },
            },
        },
        breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
        typography: themeTypography(themeOption),
        customShadows: customShadows(settings.mode, themeOption),
        components: componentStyleOverrides(themeOption),
    });
};

export default theme;
